const A = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMmE3IDcgMCAwIDEgMCAxNGgtMnYyaC0ydjJIOXYySDJ2LTUuNDE0bDYuMTQ4LTYuMTQ4QTcgNyAwIDAgMSAxNSAyem0wIDJhNSA1IDAgMCAwLTQuNzg2IDYuNDUzbC4xNzQuNTczTDQgMTcuNDE0VjIwaDN2LTJoMnYtMmgydi0yaDRhNSA1IDAgMCAwIDAtMTB6bTAgM2EyIDIgMCAxIDEgMCA0IDIgMiAwIDAgMSAwLTR6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  A as default
};
//# sourceMappingURL=key_on-b68c6db5.mjs.map
